var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2" },
    [
      _c("ListItem", {
        attrs: { "is-recipient": "", info: "" },
        scopedSlots: _vm._u([
          {
            key: "text",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "message-list--item-vita-upload p-0" },
                  [
                    _c("div", [_c("Icon", { attrs: { icon: "vita" } })], 1),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "a",
                        { attrs: { href: _vm.vitaUrl, target: "_blank" } },
                        [_vm._v(_vm._s(_vm.vitaInfo.documentName))]
                      )
                    ])
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("ListItem", {
        attrs: { "is-recipient": "" },
        scopedSlots: _vm._u([
          {
            key: "text",
            fn: function() {
              return [
                _vm._v("\n\t\t\tJetzt solltest du schnell reagieren!\n\t\t")
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }